(() => {
  'use strict';
  const controllers = new WeakMap();
  function init(scope = document) {
    const headers = scope.matches?.('[data-mx-department-header]') ? [scope] : scope.querySelectorAll('[data-mx-department-header]');
    headers.forEach(header => {
      if (controllers.has(header)) return;
      const abort = new AbortController();
      const on = (target, event, listener, capture = false) => target?.addEventListener(event, listener, { signal: abort.signal, capture });
      const items = Array.from(header.querySelectorAll('[data-mx-department]')).map(root => ({
        root, link: root.querySelector('[data-mx-department-link]'), toggle: root.querySelector('[data-mx-department-toggle]'), panel: root.querySelector('[data-mx-department-panel]'), mode: root.dataset.mxDepartmentMode
      }));
      const backdrop = header.querySelector('[data-mx-department-backdrop]');
      const mobileMenu = header.querySelector('.mx-mobile-menu');
      const desktop = window.matchMedia('(min-width: 901px)');
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      let active = null;
      let closeTimer = 0;
      let suppressFocus = false;
      let suppressHover = null;
      const position = () => {
        if (!active || active.mode !== 'desktop') return;
        header.style.setProperty('--mx-department-top', `${Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom))}px`);
      };
      const cancelClose = () => { window.clearTimeout(closeTimer); closeTimer = 0; };
      function close(restoreFocus = false) {
        cancelClose();
        const previous = active;
        if (!previous) return;
        previous.panel.hidden = true;
        previous.toggle.setAttribute('aria-expanded', 'false');
        previous.root.removeAttribute('data-mx-department-open');
        active = null;
        backdrop.hidden = true;
        if (restoreFocus) {
          suppressHover = previous.root.matches(':hover') ? previous : null;
          suppressFocus = true;
          previous.link.focus({ preventScroll: true });
          suppressFocus = false;
        }
      }
      function open(item) {
        if (item.mode === 'desktop' && !desktop.matches) return;
        if (item.mode === 'mobile' && desktop.matches) return;
        cancelClose();
        if (active === item) return;
        close();
        active = item;
        item.panel.hidden = false;
        item.toggle.setAttribute('aria-expanded', 'true');
        item.root.setAttribute('data-mx-department-open', '');
        backdrop.hidden = item.mode !== 'desktop';
        position();
      }
      function scheduleClose(item) {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (active === item && !item.panel.contains(document.activeElement)) close();
        }, 140);
      }
      items.forEach(item => {
        on(item.root, 'pointerenter', event => {
          if (item.mode !== 'desktop' || !finePointer.matches || event.pointerType === 'touch' || suppressHover === item) return;
          open(item);
        });
        on(item.root, 'pointerleave', () => {
          if (suppressHover === item) suppressHover = null;
          if (item.mode === 'desktop') scheduleClose(item);
        });
        on(item.root, 'focusin', event => {
          if (item.mode === 'desktop' && !suppressFocus && event.target !== item.toggle) open(item);
        });
        on(item.root, 'focusout', event => {
          if (!item.root.contains(event.relatedTarget)) scheduleClose(item);
        });
        on(item.toggle, 'click', () => {
          suppressHover = null;
          if (active === item) close(); else open(item);
        });
        on(item.root.querySelector('[data-mx-department-close]'), 'click', () => close(true));
        on(item.link, 'keydown', event => {
          if (event.key !== 'ArrowDown' || item.mode !== 'desktop') return;
          event.preventDefault();
          suppressHover = null;
          open(item);
          item.panel.querySelector('a[href]')?.focus();
        });
      });
      on(backdrop, 'click', () => close(true));
      on(document, 'pointerdown', event => {
        if (active && !active.root.contains(event.target) && !backdrop.contains(event.target)) close();
      });
      on(document, 'keydown', event => {
        if (event.key !== 'Escape' || !active) return;
        event.preventDefault();
        event.stopPropagation();
        close(true);
      }, true);
      on(mobileMenu, 'toggle', () => { if (!mobileMenu.open && active?.mode === 'mobile') close(); });
      on(desktop, 'change', () => close());
      on(finePointer, 'change', () => close());
      on(window, 'resize', position);
      on(window, 'scroll', position);
      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(position) : null;
      resizeObserver?.observe(header);
      const controller = { destroy: () => { close(); abort.abort(); resizeObserver?.disconnect(); controllers.delete(header); } };
      controllers.set(header, controller);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-mx-department-header]').forEach(header => controllers.get(header)?.destroy());
  });
})();
